import React from "react";
import {AiFillDelete} from 'react-icons/ai';

function Note(props) {
  function handleClick() {
    props.onDelete(props.id);
  }

  return (
    <div className="note">
      <h1>{props.title}</h1>
      <p>{props.content}</p>
      <button>
      <AiFillDelete onClick={handleClick} className="Fdelete"/>
      </button>
    </div>
  );
  
}

export default Note;
